import { render, staticRenderFns } from "./ChangeConfig.vue?vue&type=template&id=8b0dadd4"
import script from "./ChangeConfig.vue?vue&type=script&lang=js"
export * from "./ChangeConfig.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports